import {Item} from "@/api/item";

export class Order extends Item {
    method = 'order';
    activate(id) {
        return this.request({}, `${this.method}/activate/${id}`);
    }
}